import { Box, Button, Stack, TextField, Typography } from '@mui/material';
import { FunctionComponent, useState } from 'react';
import { LoadingButton } from '@mui/lab';
import { useAuthentication } from '@/hooks/useAuthentication';
import { usePostCardCodeMutation } from '@/api/v2/cardCodes';
import { useNotification } from '@starjack/features/notifications';

type NewSpecialTarifCardProps = {
    onClose: () => void;
};
export const NewSpecialTarifCard: FunctionComponent<
    NewSpecialTarifCardProps
> = ({ onClose }) => {
    const {
        liftOperatorData: { liftOperatorId },
    } = useAuthentication();
    const { addNotification } = useNotification();
    const [count, setCount] = useState(0);
    const [name, setName] = useState('');
    const [postCardCode, { isLoading }] = usePostCardCodeMutation();
    const onNameChange = (e) => {
        const { value } = e.target;

        setName(value);
    };

    const onCodesChange = (e) => {
        const { value } = e.target;

        const nextCount = parseInt(value);

        if (!isNaN(nextCount)) {
            setCount(nextCount);
        }
    };

    const onAddCardCode = () => {
        postCardCode({
            count,
            externalCode: name,
            liftOperatorId,
        })
            .unwrap()
            .then(() => {
                addNotification({
                    type: 'success',
                    message: 'Neuer Spezialtarif angelegt',
                });
            })
            .catch(() => {
                addNotification({
                    type: 'error',
                    message:
                        'Fehler beim Anlegen. Bitte später noch einmal versuchen',
                });
            });
    };

    return (
        <Box sx={{ width: '440px' }}>
            <Box
                sx={{
                    bgcolor: 'primary.main',
                    color: '#fff',
                    p: 4,
                }}
            >
                <Typography variant='h6'>
                    Neuen Spezial Tarif anlegen
                </Typography>
            </Box>
            <Stack
                sx={{
                    p: 4,
                }}
                spacing={3}
            >
                <TextField
                    onChange={onNameChange}
                    value={name}
                    label='Name der Freigabegruppe'
                />
                <TextField
                    onChange={onCodesChange}
                    value={count}
                    type='number'
                    label='Anzahl Freigabe-Codes zur Weitergabe an die Gäste'
                />

                <LoadingButton
                    onClick={onAddCardCode}
                    loading={isLoading}
                    variant='contained'
                >
                    Speichern
                </LoadingButton>

                <Box
                    sx={{
                        display: 'flex',
                        width: '100%',
                    }}
                >
                    <Button
                        sx={{
                            mx: 'auto',
                            width: 200,
                        }}
                        onClick={onClose}
                        variant='outlined'
                    >
                        Abbrechen
                    </Button>
                </Box>
            </Stack>
        </Box>
    );
};
